module.exports = __webpack_public_path__ + "media/images/hand@2x-e1ccfd99.png";